import React, { useState, useEffect } from 'react';
import SelectBoxPlayer from '../../components/customLayout/selectBoxPlayer';
import TournamentInformation from '../../components/customLayout/TournamentInformation';
import { Player } from '../../types/types';
import { useTournamentStore } from '../../store/tournamentStore';
import { Button } from '../../components/ui/button';
import { PlusIcon } from '@heroicons/react/24/outline';
import AddNewPlayer from './AddNewPlayer';
import TournamentPlayerTable from './TournamentPlayerTable';

const TournamentCaptureTab: React.FC = () => {
  const information = useTournamentStore((state) => state.information);
  const players = useTournamentStore((state) => state.players);
  const activePlayers = useTournamentStore((state) => state.activePlayers);
  const addActivePlayer = useTournamentStore((state) => state.addActivePlayer);
  const removeActivePlayer = useTournamentStore(
    (state) => state.removeActivePlayer,
  );

  const [playerBox, setPlayerBox] = useState(false);
  const [attentionSelectPlayer, setAttentionSelectPlayer] = useState(true);

  const [remainingPlayers, setRemainingPlayers] = useState(
    information.numberOfPlayers + information.numberOfSubstitute,
  );

  useEffect(() => {
    setRemainingPlayers(
      information.numberOfPlayers +
        information.numberOfSubstitute -
        activePlayers.length,
    );
  }, [
    activePlayers,
    information.numberOfPlayers,
    information.numberOfSubstitute,
  ]);

  const handlePlayerItemClick = (player: Player) => {
    setAttentionSelectPlayer(false);
    if (activePlayers.some((p) => p.id === player.id)) {
      removeActivePlayer(player.id);
      return;
    }

    if (
      activePlayers.length >=
      information.numberOfPlayers + information.numberOfSubstitute
    ) {
      alert(
        `Sie können nicht mehr als ${information.numberOfPlayers + information.numberOfSubstitute} Spieler zur Liste hinzufügen.`,
      );
      return;
    }

    addActivePlayer({ ...player, pending: false });
  };

  return (
    <>
      <TournamentInformation />
      <div className="flex flex-wrap gap-2 items-center justify-between">
        <div className="grid gap-2">
          <div
            className={`${attentionSelectPlayer && players.length > 0 && 'blinking-border inline-block rounded-md'}`}
          >
            <SelectBoxPlayer
              label="Bitte SpielerIn auswählen"
              activeGender={information.gender}
              items={players}
              activeItems={activePlayers}
              multipleSelect
              onItemClick={handlePlayerItemClick}
            />
          </div>
        </div>

        {remainingPlayers > 0 && (
          <Button
            className={`${playerBox && 'bg-red-600 hover:bg-red-700'} `}
            onClick={() => setPlayerBox(!playerBox)}
          >
            {playerBox ? (
              <>Abbrechen und schließen</>
            ) : (
              <>
                {' '}
                <PlusIcon />
                Neuen Spieler
              </>
            )}
          </Button>
        )}
      </div>
      {remainingPlayers > 0 && playerBox && (
        <div className="grid gap-4">
          <div className="border bg-yellow-50 leading-6 text-xs border-yellow-300 p-4 rounded-md relative">
            ⚠️ Bitte geben Sie mindestens 3 Buchstaben von den Vornamen und
            Nachnamen an. <br />
            🔢 Die führenden Nullen bei der 6-stelligen Mitgliedsnummer müssen
            nicht eingegeben werden. <br />
            👥 Sie können bis zu 10 Personen für dieses Turnier melden.
            <div className="absolute -bottom-1.5 -z-20 rotate-45 left-10 w-2.5 h-2.5 bg-yellow-400"></div>
          </div>

          <AddNewPlayer
            key={activePlayers.length}
            tournamentId={information.id}
            maxPlayers={remainingPlayers}
            activeGender={information.gender || 'MW'}
          />
        </div>
      )}
      <div className="grid gap-2">
        <div className="p-2 font-medium text-md">
          🏌️Sie können{' '}
          {information.numberOfPlayers + information.numberOfSubstitute} Spieler
          hinzufügen{' '}
          <span className="text-red-500">({remainingPlayers} verbleiben)</span>
        </div>
        <TournamentPlayerTable />
      </div>
    </>
  );
};

export default TournamentCaptureTab;
